import { Controller } from "@hotwired/stimulus"

// All and None for one shelf of tool switches on the team page (accounts/team/show): every switch on the shelf on, or
// off. Nothing saves until Save. Without JavaScript the two buttons stay hidden and each switch is flipped by hand.
export default class extends Controller {
  static targets = ["box"]

  connect() {
    this.element.querySelectorAll("[data-action^='check-all#']").forEach((button) => (button.hidden = false))
  }

  all() {
    this.flip(true)
  }

  none() {
    this.flip(false)
  }

  flip(on) {
    this.boxTargets.forEach((box) => (box.checked = on))
  }
}
